module.exports = __webpack_public_path__ + "img/ma212.36cb54ef.png";